module.exports = __webpack_public_path__ + "img/UBC_Logo.5460202b.png";